/*
 * @Description: 机构审核详情对话框中各面板共用的数据
 * @Author: wanqian
 * @Date: 2021-06-07 18:28:58
 */
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
    mode: "",
    baseInfoDO: {},
    openingHsvcList: {},
    logoFile: null,
    picFile: null
};

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeBaseInfoDO(stateN, baseInfoDO) {
        stateN.baseInfoDO = baseInfoDO;
    },

    changeOpeningHsvcList(stateN, openingHsvcList) {
        stateN.openingHsvcList = openingHsvcList;
    },

    changeLogoFile(stateN, logoFile) {
        stateN.logoFile = logoFile;
    },

    changePicFile(stateN, picFile) {
        stateN.picFile = picFile;
    }
};

export default new Vuex.Store({
    state: state,
    mutations: mutations
});


// WEBPACK FOOTER //
// ./src/components/review/components/InstReviewDetails/InstReviewStore.js